const API_BASE_URL =
  process.env.REACT_APP_API_URL || process.env.REACT_APP_THEME_API_URL || 'http://localhost:8000'

function getAuthHeaders(): Record<string, string> {
  const authKey = 'impersonating-auth-token'
  const authData = localStorage.getItem(authKey)
  let token: string | null = null
  if (authData) {
    try {
      const auth = JSON.parse(authData)
      token = auth.api_token
    } catch {
      // ignore
    }
  }
  if (!token) {
    token =
      localStorage.getItem('access_token') ||
      localStorage.getItem('token') ||
      localStorage.getItem('auth_token')
  }
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  }
  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }
  return headers
}

export interface RdStationStatusResponse {
  is_configured: boolean
  // Inclui o segredo do webhook (backend F-25) — só vem preenchido para admin/gestor da
  // instância; null para os demais usuários (ver RdStationIntegrationController::getStatus()).
  webhook_url: string | null
}

class RdStationApiService {
  async getStatus(): Promise<RdStationStatusResponse> {
    const response = await fetch(`${API_BASE_URL}/api/rd-station/status`, {
      method: 'GET',
      headers: getAuthHeaders(),
    })
    if (!response.ok) throw new Error('Erro ao carregar status do RD Station')
    const json = await response.json()
    return json.data
  }
}

export const rdStationApiService = new RdStationApiService()
